import { createSlice } from '@reduxjs/toolkit';

export const statusSlice = createSlice({
  name: 'status',
  initialState: {
    forcedReload: false,
    producing: false, //refers to when producing media confirmed
    peerJoined: false, //refers to when meeting is actively joined
  },
  reducers: {
    setForcedReload: (state, action) => {
      state.forcedReload = action.payload;
    },
    setProducing: (state, action) => {
      state.producing = action.payload;
    },
    setPeerJoined: (state, action) => {
      state.peerJoined = action.payload;
    },
  },
});

export const { setForcedReload, setProducing, setPeerJoined } =
  statusSlice.actions;

export default statusSlice.reducer;
